<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 13.25h-.31l-1.61-4.86 1.73.34H21a1 1 0 00.19-2l-7.31-1.38A2 2 0 0013 4.28V3a1 1 0 00-2 0v1.28a2 2 0 00-.5.41L3.19 3.27a1 1 0 00-.38 2l2.27.44L3.31 11H3a1 1 0 00-1 1 4 4 0 008 0 1 1 0 00-1-1h-.31L7.05 6.06l3.07.59A2 2 0 0011 7.72V20H8a1 1 0 000 2h8a1 1 0 000-2h-3V7.72a2 2 0 00.5-.41l3.56.69-1.75 5.25H15a1 1 0 00-1 1 4 4 0 008 0 1 1 0 00-1-1zM6 14a2 2 0 01-1.73-1h3.46A2 2 0 016 14zm-1.64-3L6 6.08 7.64 11zM18 8.33l1.64 4.92h-3.28zm0 7.92a2 2 0 01-1.73-1h3.46a2 2 0 01-1.73 1z"/></svg>